export const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
export const passwordRegex = /^(?=.*[A-Z])(?=.*[0-9]).{8,}$/
export const enableOnlyKorEngNumber = /^[가-힣A-Z0-9]*$/
